import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/AuthSlice";
import usersReducer from "../features/UsersSlice";
import vehicleReducer from "../features/VehicleSlice";

const persistMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  const { token } = store.getState().auth;
  localStorage.setItem("token", token?.token);
  localStorage.setItem("user", JSON.stringify(token?.user));
  return result;
};

export const store = configureStore({
  reducer: { auth: authReducer, users: usersReducer, vehicles: vehicleReducer },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(persistMiddleware),
});
